import { z } from 'zod';

// ZIP code validation regex - supports:
// 5 digits (e.g., 10001)
// 9 digits (e.g., 100016789)
// 5-4 format (e.g., 10001-6789)
export const zipRegex = /^(\d{5}|\d{9}|\d{5}-\d{4})$/;

// Phone validation regex - requires international calling code:
// +41 123 4567890, +1 555-123-4567, +44 20 7946 0958
// Must start with + followed by country code and at least 10 digits
export const phoneRegex = /^\+[0-9\s\-().]{9,20}$/;

export const addressSchema = z.object({
  name: z.string().min(2, 'Full name is required').max(100, 'Full name must be at most 100 characters'),
  street1: z.string().min(5, 'Address is required').max(200, 'Address must be at most 200 characters'),
  street2: z.string().max(200, 'Address must be at most 200 characters').optional(),
  city: z.string().min(2, 'City is required').max(100, 'City must be at most 100 characters'),
  state: z.string().min(2, 'State is required').max(100, 'State must be at most 100 characters'),
  zip: z.string()
    .min(1, 'ZIP code is required')
    .max(20, 'ZIP code must be at most 20 characters')
    .refine(val => zipRegex.test(val), {
      message: 'Please enter a valid ZIP code (e.g., 10001 or 10001-6789)',
    }),
  country: z.string().min(2, 'Country is required').max(100, 'Country must be at most 100 characters'),
  phone: z.string()
    .min(1, 'Phone number is required')
    .refine(val => phoneRegex.test(val), {
      message: 'Invalid phone number. Include international calling code (e.g., +1 or +41)',
    }),
});

export type AddressFormData = z.infer<typeof addressSchema>;